import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuthPayload } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        applyAuthPayload(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data } });
      } catch (e) {
        setError("Sign-in failed. Try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, applyAuthPayload]);

  return (
    <div className="min-h-screen grid place-items-center bg-zinc-950 text-zinc-100">
      <div className="text-center">
        <div className="h-8 w-8 border-2 border-orange-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Connecting to shop…</div>
        {error ? <div className="text-red-400 text-sm mt-4">{error}</div> : null}
      </div>
    </div>
  );
}
